import { useTheme } from '@mui/material';

export default function QuickActionIcon() {
  const theme = useTheme();
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z'
        fill='white'
        fill-opacity='0.6'
      />
      <path
        d='M13.125 21.25L21.875 11.875L20 18.75H26.875L18.125 28.125L20 21.25H13.125Z'
        stroke={theme.palette.primary.main}
        stroke-width='1.66667'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
